import { render } from "./OverviewTab.vue?vue&type=template&id=439c796a&scoped=true"
import script from "./OverviewTab.vue?vue&type=script&lang=js"
export * from "./OverviewTab.vue?vue&type=script&lang=js"

import "./OverviewTab.vue?vue&type=style&index=0&id=439c796a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439c796a"]])

export default __exports__